import "./container.css";
import "./WhyConsolidate.css";

const ITEMS = [
  "Credit Card Outstanding",
  "Personal Loans",
  "Buy Now Pay Later",
  "Overdrafts & Small Loans",
];

const WhyConsolidate = () => {
  return (
    <section className="why-consolidate w-full">
      <div className="container-8xl why-consolidate-inner">
        <h2
          className="why-consolidate-heading"
          style={{ fontStyle: "normal", fontFamily: "Inter" }}
        >
          What You Can <span style={{ fontWeight: 700 }}>Consolidate</span>
        </h2>

        <p
          className="why-consolidate-subtext"
          style={{ fontStyle: "normal", fontWeight: 400, fontFamily: "Inter" }}
        >
          Bring Everything Under One Roof
        </p>

        <div className="why-consolidate-pill">
          {ITEMS.map((item, index) => (
            <span key={item} style={{ display: "contents" }}>
              <span
                className="why-consolidate-item"
                style={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "28px",
                  letterSpacing: "-0.258px",
                }}
              >
                {item}
              </span>
              {index < ITEMS.length - 1 && <span className="why-consolidate-dot">•</span>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyConsolidate;
